module.exports = __webpack_public_path__ + "img/card-i7.4c53a5eb.png";